import { Users, ClipboardList, Clock, Loader2, CheckCircle2, AlertTriangle, CalendarClock } from "lucide-react";
import { SummaryCard } from "./SummaryCard";
import { ComplaintTrendChart } from "./ComplaintTrendChart";
import { EmployeePerformanceCard } from "./EmployeePerformanceCard";
import { NotificationsPanel } from "./NotificationsPanel";
import { useDashboardSummary } from "@/hooks/useDashboard";
import { useAuthStore } from "@/store/auth.store";

export function DashboardPage() {
  const { data: summary, isLoading } = useDashboardSummary();
  const role = useAuthStore((s) => s.user?.role);
  const user = useAuthStore((s) => s.user);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-semibold">
          {role === "ADMIN" ? "Dashboard" : `Welcome back, ${user?.fullName?.split(" ")[0] ?? ""}`}
        </h1>
        <p className="text-sm text-muted-foreground">
          {role === "ADMIN"
            ? "Company-wide overview of jobs, customers, and technicians."
            : "Here's what's on your plate today."}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-7">
        {role === "ADMIN" && (
          <SummaryCard label="Customers" value={summary?.totalCustomers} icon={Users} isLoading={isLoading} />
        )}
        <SummaryCard
          label="Total Complaints"
          value={summary?.totalComplaints}
          icon={ClipboardList}
          isLoading={isLoading}
        />
        <SummaryCard label="Pending" value={summary?.pending} icon={Clock} isLoading={isLoading} />
        <SummaryCard
          label="In Progress"
          value={summary?.inProgress}
          icon={Loader2}
          tone="accent"
          isLoading={isLoading}
        />
        <SummaryCard
          label="Completed"
          value={summary?.completed}
          icon={CheckCircle2}
          tone="success"
          isLoading={isLoading}
        />
        <SummaryCard
          label="Overdue"
          value={summary?.overdue}
          icon={AlertTriangle}
          tone="destructive"
          isLoading={isLoading}
        />
        <SummaryCard
          label="Today's Jobs"
          value={summary?.todaysJobs}
          icon={CalendarClock}
          isLoading={isLoading}
        />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ComplaintTrendChart />
        </div>
        <NotificationsPanel />
      </div>

      {role === "ADMIN" && <EmployeePerformanceCard />}
    </div>
  );
}
